import { TextField } from '@material-ui/core'
import { RenderInputParams } from '@material-ui/lab'
import React from 'react'

export default function RenderInput(lable: string) {
    return function RenderInputResult(params: RenderInputParams): JSX.Element {
        return <TextField {...params} label={lable} fullWidth={true} variant="filled" margin={'dense'} />
    }
}
